import { render, staticRenderFns } from "./SelectAllObjectsButton.vue?vue&type=template&id=35e9b0fe&scoped=true"
import script from "./SelectAllObjectsButton.vue?vue&type=script&lang=js"
export * from "./SelectAllObjectsButton.vue?vue&type=script&lang=js"
import style0 from "./SelectAllObjectsButton.vue?vue&type=style&index=0&id=35e9b0fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9b0fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e9b0fe')) {
      api.createRecord('35e9b0fe', component.options)
    } else {
      api.reload('35e9b0fe', component.options)
    }
    module.hot.accept("./SelectAllObjectsButton.vue?vue&type=template&id=35e9b0fe&scoped=true", function () {
      api.rerender('35e9b0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/SelectAllObjectsButton.vue"
export default component.exports